import { CATEGORY_IDS } from "~/const/categories";
import type { G_VideoCategory } from "~/lib/graphql";

export const isGravureCategory = (categories?: Pick<G_VideoCategory, "id">[]) => {
  return categories?.some((category) => category.id === CATEGORY_IDS.GRAVURE);
};
